"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _getTranslationsProps = require("./getTranslationsProps");
Object.keys(_getTranslationsProps).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getTranslationsProps[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getTranslationsProps[key];
    }
  });
});
